import z from 'zod';

const requestCancellationFormSchema = z.object({
    cancellationReasonId: z.number({
        required_error: 'Please select a cancellation reason',
    }).int().positive().gt(0),
    notes: z.string().optional(),
    services: z.array(z.number().int().positive().gt(0)).min(1, 'Must request to cancel at least one service'),
});

type RequestCancellationFormValues = z.infer<typeof requestCancellationFormSchema>;

export { requestCancellationFormSchema, RequestCancellationFormValues };
